// extracted by mini-css-extract-plugin
export default {"logo":"Logo_logo__+r9S6","logo_s":"Logo_logo_s__S9bsA"};